import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlModule } from '@Work/Accounts/proprietary/controls/control.module';
//import { RouterModule } from '@angular/router';
import { PipeModule } from '@Shared/Pipes/proprietary/pipe.module';
//import { DebugModule } from '../debug/debug.module';
import { DirectiveModule } from '@Shared/Directives/proprietary/directive.module';

@NgModule({
    imports: [
        CommonModule,
        DirectiveModule
        //PipeModule,
        //DebugModule,
        //RouterModule
    ],
    declarations: [],
    exports: [
        CommonModule,
        FormsModule,
        PipeModule,
        //DebugModule,
        ControlModule,
        ReactiveFormsModule,
        DirectiveModule
        //RouterModule
    ]
})
export class SharedPageModule { }
